export interface ISubjectFrontEndModel {
  id: number;
  name: string;
  icon: string;
}

export interface DetailConfig {
  type: number;
  name: string;
  isRequired: boolean;
}

export enum DetailType {
  Bio = 1,
  Education = 2,
  Experience = 3,
  SubjectDescription = 4,
  Calendar = 5,
}
